import { AppType } from "client/Api/Apps/common";
import { ReactElement, useCallback } from "react";
import { useRenderManager } from "../../useRenderManager";
import { YammerLiveTileContent } from "./YammerLiveTileContent";
import { TileRenderState } from "../../RenderState/common";
import { useBaseNavigation } from "../useInvokeNavigation";
import { useRegisterTileUsage } from "../useRegisterTileUsage";
import { navigateToYammerApp } from "client_legacy/Apps/appNavigation";
import { TileContextProvider } from "../../TileContextProvider";
import { Coordinate } from "client/Misc/commonTypes";

export type YammerTileContentProps = {
	renderState: TileRenderState<AppType.Yammer>;
	onOpenTileMenu: (coordinate: Coordinate) => void;
};

export const YammerTileContent = (props: YammerTileContentProps): ReactElement => {
	const {
		renderState,
		onOpenTileMenu
	} = props;

	const {
		dimension,
		data: { settings }
	} = renderState;

	const tileContent: ReactElement = useRenderManager(
		dimension,
		() => (
			<YammerLiveTileContent
				tabs={settings.tabs}
				onOpenTileMenu={onOpenTileMenu}
			/>
		)
	);

	return (
		<TileContextProvider
			renderState={renderState}
		>
			{tileContent}
		</TileContextProvider>
	);
};
YammerTileContent.displayName = "YammerTileContent";

export function useYammerTileNavigation(
	renderStateIsh: Pick<TileRenderState<AppType.Yammer>, "data" | "dimension" | "interactionState">,
	onEdit: (() => void) | undefined
): [element: ReactElement | null, () => void | Promise<void>] {
	const registerTileUsage: (() => void) = useRegisterTileUsage(renderStateIsh);

	return useBaseNavigation(
		renderStateIsh,
		onEdit,
		useCallback(
			(): void => {
				registerTileUsage();
				navigateToYammerApp();
			},
			[registerTileUsage]
		)
	);
}
